import React, { useState, useEffect } from "react";
import axios from "axios";
import $ from "jquery";


const API = "https://api.imgur.com/3";
export const params = {
  headers: { Authorization: "Client-ID 1c1f72b9f1dda9e" }
};

export const getAlbumsId = () => {
  return axios.get(`${API}/account/milovid/albums/ids/0`, {
    headers: { Authorization: "Client-ID 1c1f72b9f1dda9e" }
  });
};

export const getAlbumNameAndPhotoURL = hash => {
  return axios.get(`${API}/account/milovid/album/${hash}`, {
    headers: {
      Authorization: "Bearer 61183729e48c3cbd7d64982afd6064f78abf93ad"
    }
  });
};
  
const FabricPage = () => {
  const [albumIdList, setAlbumIdList] = useState([]);
  const [albumsAndPhotos, setAlbumsAndPhotos] = useState([]);
  const [currentAlbum, setCurrentAlbum] = useState(
    albumsAndPhotos[0] || undefined
  );
  useEffect(() => {
    getAlbumsId().then(res => setAlbumIdList(res.data.data));
  }, []);

  useEffect(() => {
    let array = [];
    for (let i = 0; i < albumIdList.length; i++) {
      getAlbumNameAndPhotoURL(albumIdList[i]).then(res => {
        i === 0 && setCurrentAlbum(res.data.data);
        array = array.concat(res.data.data);
        array = array.sort(function(a, b) {
          var nameA = a.title.toLowerCase(),
            nameB = b.title.toLowerCase();
          if (nameA < nameB)
            //сортируем строки по возрастанию
            return -1;
          if (nameA > nameB) return 1;
          return 0; // Никакой сортировки
        });
        setAlbumsAndPhotos(array);
        setCurrentAlbum(array[0]);
      });
    }
  }, [albumIdList]);

  const handleChangeCurrentAlbum = id => {
    const kek = albumsAndPhotos.filter(album => album.id === id);
    setCurrentAlbum(kek[0]);
  };

  useEffect(()=>{
    $(".image").click(function() {
      // Событие клика на маленькое изображение
      var img = $(this); // Получаем изображение, на которое кликнули
      var src = img.attr("src"); // Достаем из этого изображения путь до картинки
      $("body").append(
        "<div class='popup'>" + //Добавляем в тело документа разметку всплывающего окна
        "<div class='popup_bg'></div>" + // Блок, который будет служить фоном затемненным
        "<img src='" +
        src +
        "' class='popup_img' />" + // Само увеличенное фото
          "</div>"
      );
      $(".popup").fadeIn(800); // Медленно выводим изображение
      $(".popup_bg").click(function() {
        // Событие клика на затемненный фон
        $(".popup").fadeOut(800); // Медленно убираем всплывающее окно
        setTimeout(function() {
          // Выставляем таймер
          $(".popup").remove(); // Удаляем разметку всплывающего окна
        }, 800);
      });
    });  
  });

  return (
    <>
      <header className="header-index">
        <div className="container">
          <div className="title">
            <a href="../index.php">
              <img src="image/logo_milovid.png" alt="Logo" />
            </a>
            <div className="name">
              <a href="../index.php">
                <h1>Миловид</h1>
                <h2>
                  Рол-штори, жалюзі,
                  <br />
                  вікна, двері, ролети
                </h2>
              </a>
            </div>
          </div>
          <div className="nav_elem">
            <div className="phone">
              <div className="svggg">
                <img src="image/phone.png" alt="phone" />
              </div>
              <span>
                <a href="tel: +380472382117">(0472) 382-117</a> <br />
                <a href="tel: +380672396114">(067) 239-6114</a> <br />
                <a href="tel: +380731604276">(073) 160-4276</a> <br />
              </span>
            </div>
            <a href="#">
              <div className="viber">
                <div className="svggg">
                  <a href="viber://chat?number=+380731604276">
                    <img src="image/viber_1-01.svg" alt="viber" />
                  </a>
                </div>
                <span>
                  <a href="viber://chat?number=+380731604276">Viber</a>
                </span>
              </div>
            </a>
            <a href="https://goo.gl/maps/P3WDzGn8AUt" target="_blank">
              <div className="location">
                <div className="svggg">
                  <img src="image/map.png" alt="location" />
                </div>
                <span>
                  м. Черкаси <br />
                  бул. Шевченка, 145, офіс 117
                </span>
              </div>
            </a>
            <div className="mail">
              <div className="svggg">
                <img src="image/mail.png" alt="mail" />
              </div>
              <a href="mailto: milovid@ukr.net">
                <span>milovid@ukr.net</span>
              </a>
            </div>
            <div className="vk">
              <a href="https://www.instagram.com/milovid_com_ua/?hl=ru">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  className="svg1"
                >
                  <use
                    href="image/instagram.svg#insta"
                    width="22"
                    height="22"
                  ></use>
                </svg>
              </a>
            </div>
            <div className="fb" id="Fb">
              <a href="https://www.facebook.com/com.milovid/">
                <img src="image/facebook_logo.png" alt="Fb" />
              </a>
            </div>
            <div className="none_menu" onClick="showMenu()">
              &#9776;
            </div>
          </div>
        </div>
        <div className="nav_container">
          <div className="nav">
            <ul id="one">
              <li>
                <a href="../index.php">Головна</a>
              </li>
              <li>
                <a href="production.php">Продукція</a>
              </li>
              <li>
                <a href="portfolio.php">Наші роботи</a>
              </li>
              <li>
                <a href="contacts.php">Контакти</a>
              </li>
              <li>
                <a href="tissue.php">Тканини</a>
              </li>
            </ul>
            <div className="dollar" id="two">
              {/*Курс доллара:
              <span id="dollar">
                {buks}
                  <?php $textfile = "http://milovid.com.ua/dollar.txt"; //путь к файлу

						if ($quotes = @file("$textfile")) {$quote = rand(0, sizeof($quotes)-1);

						echo $quotes[$quote]; 

						}else{echo ("Нет контента");} //вывод сообщения, если файл не найден 
						?> 
              </span>*/}
            </div>
          </div>
        </div>
      </header>
      <div id="mobile-menu-block" style={{ display: "none" }}>
        <ul>
          <li>
            <a href="../index.php">Головна</a>
          </li>
          <li>
            <a href="production.php">Продукція</a>
          </li>
          <li>
            <a href="portfolio.php">Наші роботи</a>
          </li>
          <li>
            <a href="contacts.php">Контакти</a>
          </li>
        </ul>
      </div>
      <section className="production" id="production">
        <div className="wrap_prod" id="showMain">
          <div className="nav_left">
            <h4>Тканини</h4>
            <ul className="nav_item">
              {albumsAndPhotos &&
                albumsAndPhotos.map(item => (
                  <li
                    key={item.id}
                    onClick={() => handleChangeCurrentAlbum(item.id)}
                  >
                    <a>{item.title}</a>
                  </li>
                ))}
            </ul>
          </div>
          <div className="main_prod">
            <h5>
              {currentAlbum === undefined ? "Тканини" : currentAlbum.title}
            </h5>
            <div className="wrap_card">
              {currentAlbum &&
                currentAlbum.images.map(image => {
                  return (
                    <div className="card" key={image.name}>
                      <div className="black_bg">
                        <img
                          src={image.link}
                          alt={image.name}
                          id="img"
                          className="image"
                        />
                        <p>{image.description}</p>
                      </div>
                    </div>
                  );
                })}
            </div>
            <div className="remont_prod">
              <img src="../image/remont_prod.png" alt="" />

              <div className="text">
                <div className="text_title">
                  Ремонт жалюзі, заміна комплектуючих.
                </div>
                <div className="text_text">
                  Наші фахівці професійно і оперативно підберуть всі необхідні
                  комплектуючи і виконають ремонт жалюзі будь-якої складності.
                </div>
                <div className="text_rem">
                  Потрібен ремонт жалюзі? Телефонуйте нам і ми допоможемо!
                </div>
                <div className="text_contact">
                  (0472) 382-117 (067) 239-6114 (073) 160-4276
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer>
        <div className="fot_container">
          <div className="map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2593.882741344697!2d32.05036990000001!3d49.4489332!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40d14dac06902c01%3A0xb4104f64d53f26e3!2sShevchenka%20Blvd%2C%20170%2C%20Cherkasy%2C%20Cherkas'ka%20oblast%2C%2018000!5e0!3m2!1sen!2sua!4v1736709835853!5m2!1sen!2sua"
              width="380"
              height="410"
              frameBorder="0"
              style={{ border: 0 }}
              allowFullScreen
            ></iframe>
          </div>
          <div className="contacts">
            <h5>
              Ми підберемо найкраще <br />
              рішення саме для вас
            </h5>
            <ul>
              <li>
                <a href="https://goo.gl/maps/P3WDzGn8AUt" target="_blank">
                  <div className="cont_img">
                    <img src="image/map_foot.png" alt="map" />
                  </div>
                </a>
                <a href="https://goo.gl/maps/P3WDzGn8AUt" target="_blank">
                  м. Черкаси, бул.Шевченка, 145, офіс 117, (1-й поверх)
                </a>
              </li>
              <li>
                <a href="https://goo.gl/maps/P3WDzGn8AUt">
                  <div className="cont_img">
                    <img src="image/time.png" alt="time" />
                  </div>
                </a>
                <a href="https://goo.gl/maps/P3WDzGn8AUt" target="_blank">
                  пн-пт: 9-00 – 18-00
                </a>
              </li>
              <li>
                <a href="#">
                  <div className="cont_img">
                    <a href="tel: +380472382117">
                      <img src="image/phone_foot.png" alt="phone" />
                    </a>
                  </div>
                </a>
                <div className="wrapper">
                  <a href="tel: +380472382117">(0472) 382-117</a>
                  <br />
                  <a href="tel: +380672396114">(067) 239-6114</a>
                  <br />
                  <a href="tel: +380731604276">(073) 160-4276</a>
                  <br />
                </div>
              </li>
              <li>
                <a href="#">
                  <div className="cont_img">
                    <a href="viber://chat?number=380672396114">
                      <img src="image/viber_1-01.svg" alt="viber" />
                    </a>
                  </div>
                </a>
                <a href="viber://chat?number=380672396114">Viber</a>
              </li>
              <li>
                <a href="mailto: milovid@ukr.net">
                  <div className="cont_img">
                    <img src="image/mail_foot.png" alt="mail" />
                  </div>
                </a>
                <a href="mailto: milovid@ukr.net">milovid@ukr.net</a>
              </li>
            </ul>
          </div>
          <div className="forms">
            <h5>
              Будь ласка, залиште свої контакти
              <br />і ваше запитання, ми з вами зв'яжемося!
            </h5>
            <form method="post" className="form-contacts" action="../send.php">
              <p className="hint-form">
                <span>*</span> - поля обов'язкові для заповнення
              </p>
              <input type="text" placeholder="* Ваше ім'я" name="name" />
              <input type="email" placeholder="* E-mail" name="email" />
              <input type="tel" placeholder="* Телефон" name="phone" />
              <input
                type="text"
                placeholder="* Ваше запитання"
                name="question"
              />
              <button type="submit">Надіслати</button>
            </form>
          </div>
        </div>
        <div className="bottom_container">
          <div className="unicode_st">
            <div className="footer_title">
              <img src="image/logo_milovid.png" alt="logo" />
              <div className="wrapper">
                <h5>Миловид</h5>
                <h6>
                  Виготовлення та встановлення різних видів жалюзі, захисних
                  ролет, гаражних воріт, москітних сіток, вікна і двері ПВХ,
                  рефлексороли, маркізи, ремонт жалюзі.
                </h6>
              </div>
            </div>
            <div className="copyright">Copyright © 2015-2020. Миловид</div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default FabricPage;
